import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c8e5d672"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout-topbar" }
const _hoisted_2 = { style: {"height":"100%","display":"flex","align-items":"center","justify-content":"space-between"} }
const _hoisted_3 = {
  style: {"height":"100%","display":"flex","align-items":"center"},
  class: "flex-1"
}
const _hoisted_4 = { style: {"margin-left":"8px","max-width":"200px","max-height":"60px"} }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"0px","height":"50px","border":"1px #DADCE0 solid","margin-left":"14px"} }, null, -1))
const _hoisted_7 = {
  style: {"margin-left":"6px"},
  width: "30",
  height: "24",
  viewBox: "0 0 30 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M7.2 2.23334H22.8C25.6718 2.23334 28 4.63906 28 7.60667V15.6667C28 18.6342 25.6718 21.04 22.8 21.04H7.2C4.32812 21.04 2 18.6342 2 15.6667V7.60667C2 4.63906 4.32812 2.23334 7.2 2.23334Z",
  fill: "white",
  stroke: "white",
  "stroke-width": "4",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M18.25 9.95752L15 13.3159L11.75 9.95752",
  stroke: "black",
  "stroke-opacity": "0.8",
  "stroke-width": "4",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "overlay-ul" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { style: {"width":"300px","height":"50px","margin-left":"20px"} }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-search",
  style: {"font-size":"20px","line-height":"20px","font-weight":"700","color":"black","margin-top":"-12px"}
}, null, -1))
const _hoisted_15 = {
  key: 0,
  class: "pi pi-spin pi-spinner"
}
const _hoisted_16 = {
  style: {"height":"100%","display":"flex","align-items":"center"},
  class: "layout-topbar-menu"
}
const _hoisted_17 = { style: {"margin-right":"65px"} }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "38",
  height: "38",
  viewBox: "0 0 38 38",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    width: "38",
    height: "38",
    fill: "url(#pattern0_2050_2018)"
  }),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("pattern", {
      id: "pattern0_2050_2018",
      patternContentUnits: "objectBoundingBox",
      width: "1",
      height: "1"
    }, [
      /*#__PURE__*/_createElementVNode("use", {
        "xlink:href": "#image0_2050_2018",
        transform: "scale(0.0111111)"
      })
    ]),
    /*#__PURE__*/_createElementVNode("image", {
      id: "image0_2050_2018",
      width: "90",
      height: "90",
      "xlink:href": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAD8ElEQVR4nO2dS08UQRDHKxEVo9ErDxM16BdAPYmRGPWqHtTEV8TXBRNEAnj05uNESPwaPg8Y/QAag0Hg4kW9+Ii6gJ6EBPyZCm3cA6uQ7emumelfspfN7GzVf3d6uquqa0QSiUQikUgkEolEIrE8gFXAbuACcAd4AEwAb4FpYM69pt17E+6Y2+4zu/Qcy/y6cgFsBq4Cj4Ef1M934BHQA7RKmQHWAWeAZ8AC2TEPPAVOA41SFoAN7p/2kfB8BW4Am6SoAKuBfmCK+KgNfWqTFAlgLzCJPd4AByTv6JgI3AV+YRe1bRhYK3kE2Aq8ID+8ArZLntDL0dM0LTQ6LdwveQA4Cvwkv8wBJ8QywOWM58ShUB8uiUWAI25xUBQWgONiCR3XgFmKxxxwSCwA7MjpjW8lN8i22CKvddOiojMadZ7tFiMhL+N+oNm9Btx7oRiOJfK+wCu+gSVsGAz4/eprR2iRG4BxwtK8hB1NgW2YDBqIcpdwUKS2LaHpDRlPrpRY6IpqEELokOOiRaGVvhBhz08xPBNbQn/WVFyWQp+N5BjGhFZOZim0JlKjIPaEHslK5NaYQSOxJ/RCJqUMru4iGmJPaOVKFkJrcUs0xKbQ97Io05qJ6ZHYFHrGa/mZq4WLitgUWtnpU+iLsb0Ru0J3+RRaqzqjInaFvulT6IexvRG7Qvu7IUYIieZJ6DGfQr/3kRkRY3jK1LzzaVDFZ2bEGnVGJL/5NKSeX7xZjFNnpmbWitAtYhwXxzEhdD1Dx6AYB7huZeio92Y4aPGfrTY528zcDNP0LtD0Li1YAi1Y0hI80BJcd6RGRWrbFptzPoVOYdLatPsUOgX+QwT+ndi6tzoaUtuu4qSynEO6rTgaYlPo7qwm96nc4C+qRZN3oZ3Y2iUgClLbpmIV0DintO1DFKRkJWGNkdo/UKoix1hF6AaFvpapyM6x9RoaLLHQlSCF6M45bSpSVqF7gohctVnodWAHWzxnRuxvFqrqKhNy+9ug58zISlFf9wQVucpR7dwSirk/mRpPmZGVMhRF5Kotyrp9t+i8BNZEE9qJ3eY2pheVGWCbWADozHnXmVro0HRQLAEcLmBjlGNiEW2PU5BWP/NaEy6WcS1/8jyMzJpr8fOf1j/fc3rj65Q8AWwBnpMfRqO39Klznj2cg5aZQ9HnyT4AOiyUlS3BeLRldcaBqN4YIdYl+OaSzQ1SVFiMZ6uTHyII/MU16t4oZYHFtNgp4EnGCx0994jm+ErVev4fm3auAPfd0yjqZdqdqzuzkoC8w2L5WTtwHril1UBag+weBTJV9XiQKffemDtGj+1yn02PB0kkEolEIpFIJBIJWSa/AV6GBCbKNy/yAAAAAElFTkSuQmCC"
    })
  ])
], -1))
const _hoisted_19 = { style: {"margin-right":"38px"} }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M12 35.9V33.8333C12 28.1264 16.4772 23.5 22 23.5C27.5228 23.5 32 28.1264 32 33.8333V35.9",
  stroke: "white",
  "stroke-width": "4",
  "stroke-linecap": "round"
}, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M22 23.5C25.3138 23.5 28 20.7242 28 17.3C28 13.8758 25.3138 11.1 22 11.1C18.6862 11.1 16 13.8758 16 17.3C16 20.7242 18.6862 23.5 22 23.5Z",
  stroke: "white",
  "stroke-width": "4",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M22 44.1666C33.0457 44.1666 42 34.9139 42 23.5C42 12.0861 33.0457 2.83331 22 2.83331C10.9543 2.83331 2 12.0861 2 23.5C2 34.9139 10.9543 44.1666 22 44.1666Z",
  stroke: "white",
  "stroke-width": "4"
}, null, -1))
const _hoisted_23 = [
  _hoisted_20,
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = { class: "field" }
const _hoisted_25 = {
  key: 0,
  class: "p-error"
}
const _hoisted_26 = { class: "field" }
const _hoisted_27 = {
  key: 0,
  class: "p-error"
}
const _hoisted_28 = { class: "flex justify-content-end align-items-center" }
const _hoisted_29 = { style: {"width":"100%"} }
const _hoisted_30 = { style: {"word-wrap":"break-word","width":"100%","margin":"0px"} }
const _hoisted_31 = { style: {"word-wrap":"break-word","width":"100%","margin":"0px"} }
const _hoisted_32 = { style: {"width":"100%"} }
const _hoisted_33 = { style: {"word-wrap":"break-word","width":"100%","margin":"0px"} }
const _hoisted_34 = { style: {"word-wrap":"break-word","width":"100%","margin":"0px"} }
const _hoisted_35 = { style: {"width":"100%"} }
const _hoisted_36 = { style: {"word-wrap":"break-word","width":"100%","margin":"0px"} }

import i18n from '@/locale/i18n';
import { onMounted, ref, watch } from 'vue';
import router from '@/router';
import { useToast } from 'primevue/usetoast';
import { useRoute } from 'vue-router';
import { ToastControl } from './utils/ToastControl';
import Echo from 'laravel-echo';
import { IMenus } from '@/interface/serverData/common/i-menus';

import { useRegistrationStore } from "@/store/registration/registrationStore";
import { useRegistrationListStore } from '@/store/registration/registrationListStore';
import { useAuthStore } from '@/store/auth';
import { useHolidayStore } from '@/store/common/holidayStore';

import { IChangePWDComponent } from '@/interface/component/common/i-change-pwd-component';
import { IStoreComponent } from '@/interface/component/master/i-store-component';
import { IHolidayComponent } from "@/interface/component/master/i-holiday-component";
import { IUserInfoComponent } from '@/interface/component/master/i-user-component';
import { ICountryComponent } from '@/interface/component/registration/i-registration-component';
import { IRankComponent } from '@/interface/component/master/i-rank-component';
import RegistrationListService from '@/service/registration/RegistrationListService';

import { RoleConfig } from '@/configs/role-config';
import { useLayout } from '@/utils/layout';

import { FocusControl } from '@/utils/FocusControl';
import AuthService from '@/service/auth/AuthService';
import UserService from '@/service/master/UserService';
import StoreService from '@/service//master/StoreService';
import HolidayService from "@/service/master/HolidayService";
import RegistrationService from '@/service/registration/RegistrationService';
import RankService from '@/service/master/RankService';

import { usePurposeStore } from '@/store/registration/purposeStore';
import { useSalesRouteStore } from '@/store/registration/salesRouteStore';
import { useChildFeeStore } from '@/store/common/childFeeStore';
import { useFreeMemoStore } from '@/store/common/freeMemoStore';
import { useRoomTypeStore } from '@/store/common/roomTypeStore';
import { useCountryStore } from '@/store/common/countryStore';
import { usePrefectureStore } from '@/store/common/prefectureStore';
import { useRankStore } from '@/store/common/rankStore';
import XInputText from './components/common/input/XInputText.vue';
import X1Button from './components/common/button/X1Button.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppMenuTopBar',
  setup(__props) {

const t = i18n.global.t;
const route = useRoute();
const userStore = useAuthStore();
const authService = ref(new AuthService());
const userService = ref(new UserService());
const displayFlag = ref(false);
const toast = useToast();

const pwd1 = ref('');
const pwd2 = ref('');
const userStoreId = ref(userStore!.targetStore!.storeId);
const lastStoreId = ref(userStore!.targetStore!.storeId);

const store = ref<IStoreComponent>();
const storeService = new StoreService();
const registrationService = ref(new RegistrationService());
const rankService = ref(new RankService());

const topbarImage = () => {
    // return 'images/logo_horizontal.png';
    return 'images/logo_horizontal.svg';
}

const holidayStore = useHolidayStore();
const holidayService = ref(new HolidayService());

const freeMemoStore = useFreeMemoStore();
const salesRouteStore = useSalesRouteStore();
const purposeStore = usePurposeStore();
const roomTypeStore = useRoomTypeStore();
const childFeeStore = useChildFeeStore();

const countryStore = useCountryStore();
const prefectureStore = usePrefectureStore();
const rankStore = useRankStore();

// const billingAddressStore = useBillingAddressStore();
// const accountingItemStore = useAccountingItemStore();
// const registrationSettlementDialogStore = useRegistrationSettlementDialogStore();
// const registrationReceiptDetailDialogStore = useRegistrationReceiptDetailDialogStore();

const { layoutConfig } = useLayout();

const toDashboard = () => {
    layoutConfig.activeMenuItem.value = 'ダッシュボード';
}

const requestGetStoreInformation = () => {
    return new Promise((resolve, reject) => {
        storeService.show(userStore.targetStore!)
            .then(async (response) => {
                resolve(response);
            })
            .catch((response) => {
                reject(response);
            });
    });
}

const requestGetHolidays = () => {
    return new Promise((resolve, reject) => {
        holidayService.value.list()
            .then(async (response) => {
                resolve(response);
            })
            .catch((response) => {
                reject(response);
            });
    });
}

const requestChangeStore = (userId: number, storeId: number) => {
    return new Promise((resolve, reject) => {
        userService.value.changeCurrentStore(
            userId,
            storeId
        )
            .then(async (response) => {
                resolve(response);
            })
            .catch(response => {
                reject(response);
            })
    });
}

const requestCountry = () => {
    return new Promise((resolve, reject) => {
        registrationService.value.getDropdownCountry()
            .then(async (response) => {
                resolve(response);
            })
            .catch(response => {
                reject(response);
            })
    });
}

const requestPrefectures = () => {
    return new Promise((resolve, reject) => {
        registrationService.value.getDropdownPrefectures()
            .then(async (response) => {
                resolve(response);
            })
            .catch(response => {
                reject(response);
            })
    });
}

const requestRankTypes = () => {
    return new Promise((resolve, reject) => {
        rankService.value.getDropDownList()
            .then(async (response) => {
                resolve(response);
            })
            .catch(response => {
                reject(response);
            })
    });
}

const buttonConditions = ref(['REJI_BUTTON_TEXT', 'GUEST_BUTTON_TEXT']);

const searchRejiDataInputXPosition = ref(0);

onMounted(async () => {
    registerWSListener();

    // ログインした後、休みの日を取得して、piniaに保存
    const element = document.getElementById('searchRejiDataInput');
    const rect = element!.getBoundingClientRect();
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    searchRejiDataInputXPosition.value = rect.left + scrollLeft;
    window.addEventListener('resize', function () {
        const element = document.getElementById('searchRejiDataInput');
        const rect = element!.getBoundingClientRect();
        const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
        searchRejiDataInputXPosition.value = rect.left + scrollLeft;
    });
    window.addEventListener('click', function (event) {
        if (event.target.className == 'p-dropdown-item p-highlight') {
            return;
        }
        if (!autoSearchRejiDataPanelMouseFlag.value && !autoSearchRejiDataPanelDisplayFlag.value) {
            autoSearchRejiDataPanelDisplay.value = 'none';
        }
    });

    console.log('app menu onMounted start')

    if (userStore.currentStoreInformation === null || userStore.currentStoreInformation === undefined) {
        console.log('refresh store info and holiday');
        userStore.showSpinner();

        await Promise.all([
            requestGetStoreInformation(),
            requestGetHolidays(),
            requestCountry(),
            requestPrefectures(),
            requestRankTypes()
        ])
            .then((responses) => {
                // getStoreInformation res
                if (responses.length == 5) {
                    const storeInfo = responses[0] as IStoreComponent;
                    userStore.currentStoreInformation = storeInfo;

                    const holidays = responses[1] as IHolidayComponent[];
                    holidayStore.holidays = holidays;

                    const country = responses[2] as ICountryComponent[];
                    countryStore.countries = country;

                    const prefectures = responses[3] as ICountryComponent[];
                    prefectureStore.prefectures = prefectures;

                    const ranks = responses[4] as IRankComponent[];
                    rankStore.ranks = ranks;

                } else {
                    toast.add(ToastControl.ErrorMessageWithSystemError());
                }
            })
            .catch((response) => {
                if (response!.returnCode!.substring(0, 3) === 'HOS') {
                    toast.add(ToastControl.ErrorMessage(response.message));
                } else {
                    toast.add(ToastControl.ErrorMessageWithSystemError());
                }
            })
            .finally(() => {
                console.log('app menu final')
                userStore.hideSpinner();
            })
    }
    console.log('app menu onMounted end')
})

const menusSection = (SECTION: string) => {
    let SECTION0: any[] = [];
    userStore.menus!.forEach(menu => {
        if (menu.section === SECTION) {
            SECTION0.push(menu);
        }
    })
    labelTransform(SECTION0);
    if (SECTION === 'SECTION03') {
        SECTION0.push({
            icon: 'pi pi-fw pi-user-edit', label: t('CHANGE_PASSWORD'), command: () => {

                // Show spinner
                userStore.showSpinner();

                storeService.show(userStore.targetStore!)
                    .then(data => {
                        store.value = data as IStoreComponent;

                        displayFlag.value = true;
                    })
                    .catch(response => {
                        toast.add(ToastControl.ErrorMessage(response!.data!.message));
                    })
                    .finally(() => {
                        // Hide spinner
                        userStore.hideSpinner();
                    });
            }
        });
        SECTION0.push({
            icon: 'pi pi-fw pi-sign-out', label: t('USER_LOGOUT'), command: () => {
                authService.value.logout();
                router.push('/login')

                setTimeout(() => {
                    console.log('logout')
                    unregisterAllWSChannel();
                    userStore.setDefaultState();

                    holidayStore.$reset();
                    countryStore.$reset();
                    prefectureStore.$reset();
                    rankStore.$reset();

                    // freeMemoStore.$reset();
                    // salesRouteStore.$reset();
                    // purposeStore.$reset();
                    // roomTypeStore.$reset();
                    // childFeeStore.$reset();

                    console.log(userStore);
                }, 200)
            }
        });
    }
    return SECTION0;
}

const onSelectedBtnCnd = () => {
    if (selectedButton.value == 'REJI_BUTTON_TEXT') {
        regiDataButtonClick();
    } else {
        guestDataButtonClick();
    }
}

const labelTransform = (menus: any[]) => {
    menus.forEach(menu => {
        menu.label = t(`${menu.label}`);
        if (menu.items) {
            labelTransform(menu.items);
        }
    })
}


const storeChange = async () => {
    if (userStoreId.value && lastStoreId.value !== userStoreId.value) {
        userStore!.user!.userStores.forEach(store => {
            if (store.storeId === userStoreId.value) {
                userStore!.user!.storeName = store.name;
            }
        })
        userStore!.user!.storeId = userStoreId.value;
        userStore!.targetStore!.storeId = userStoreId.value;


        userStore.showSpinner();

        console.log('change store start')

        await Promise.all([
            requestChangeStore(userStore.loggedUser!.userId, userStoreId.value),
            requestGetStoreInformation(),
            requestGetHolidays()
        ])
            .then((responses) => {
                // getStoreInformation res
                if (responses.length == 3) {

                    // requestChangeStore response
                    const data = responses[0] as IUserInfoComponent;
                    unregisterAllWSChannel();

                    userStore.bussinessDate = data.businessDate;
                    userStore.salesDate = data.salesDate;

                    userStore.targetStore = {
                        groupId: data.groupId,
                        companyId: data.companyId,
                        storeId: data.storeId,
                    };

                    userStore.user!.storeId = data.storeId;

                    const userMenus = data.menus;
                    userStore.menus = userMenus;

                    lastStoreId.value = userStoreId.value;

                    registerWSListener();

                    // requestGetStoreInformation response
                    const storeInfo = responses[1] as IStoreComponent;

                    userStore.currentStoreInformation = storeInfo;

                    // requestGetHolidays response
                    const holidays = responses[2] as IHolidayComponent[];

                    holidayStore.holidays = holidays;
                } else {
                    toast.add(ToastControl.ErrorMessageWithSystemError());
                }
            })
            .catch((response) => {
                if (response!.returnCode!.substring(0, 3) === 'HOS') {
                    toast.add(ToastControl.ErrorMessage(response.message));
                } else {
                    toast.add(ToastControl.ErrorMessageWithSystemError());
                }
            })
            .finally(() => {
                console.log('change store end')
                userStore.hideSpinner();

                countryStore.$reset();
                prefectureStore.$reset();
                rankStore.$reset();

                // freeMemoStore.$reset();
                // salesRouteStore.$reset();
                // purposeStore.$reset();
                // roomTypeStore.$reset();
                // childFeeStore.$reset();

                setTimeout(() => {
                    router.push('/?v=' + Math.random());
                }, 300)
            })
    }
}
const menu1 = ref();
const menu2 = ref();
const displayMenu1 = ref('display:none');
const displayMenu2 = ref('display:none');

const toggle = (event: any, id: string) => {
    if (id === '1') {
        displayMenu1.value = 'display:block';
        displayMenu2.value = 'display:none';
    } else {
        displayMenu2.value = 'display:block';
        displayMenu1.value = 'display:none';
    }
}

const btnBlur = (event: any, id: string) => {
    setTimeout(() => {
        if (id === '1') {
            displayMenu1.value = 'display:none';
        } else {
            displayMenu2.value = 'display:none';
        }

    }, 200);
}

watch(() => route.fullPath, (newValue, oldValue) => {
    if (newValue !== oldValue) {
        displayMenu1.value = 'display:none';
        displayMenu2.value = 'display:none';
    }
})

const inputCheck = ref(false);
const verifyPWD = ref(false);
const passwordFlag = ref(false);

const passwordValidErrorMesage = ref('');

const onSaveClick = () => {

    // HOTELOS_DEV-617 start
    function isPasswordValid(password: string, passwordPattern: string, passwordMinLength: number): boolean {
        const hasNumber = /\d/.test(password);
        const hasLetter = /[a-zA-Z]/.test(password);

        if (passwordPattern === 'AN') {
            return hasNumber && hasLetter && password.length >= passwordMinLength;
        } else if (passwordPattern === 'A') {
            return hasLetter && password.length >= passwordMinLength;
        } else if (passwordPattern === 'N') {
            return hasNumber && password.length >= passwordMinLength;
        }

        return false;
    }


    verifyPWD.value = false;
    inputCheck.value = false;
    passwordFlag.value = false;


    if (!(isPasswordValid(pwd1.value, store.value!.storeSetting!.passwordPattern, store.value!.storeSetting!.passwordMinLength))) {
        inputCheck.value = true;
        passwordFlag.value = true;

        let msgKey = 'HOS-05019-0-1';

        if (store.value!.storeSetting!.passwordPattern === 'AN') {
            msgKey = 'HOS-05019-0-1';
        } else if (store.value!.storeSetting!.passwordPattern === 'A') {
            msgKey = 'HOS-05019-0-2';
        } else if (store.value!.storeSetting!.passwordPattern === 'N') {
            msgKey = 'HOS-05019-0-3';
        }

        const p1 = t('ERROR_MESSAGE.' + msgKey);

        passwordValidErrorMesage.value = t("ERROR_MESSAGE.HOS-05019-0", [store.value!.storeSetting!.passwordMinLength, p1])

        return;
    }
    // HOTELOS_DEV-617 end

    let verify = false;
    if (pwd1.value && pwd2.value) {
        if (pwd1.value === pwd2.value) {
            verify = true;
        }
    }
    if (!verify) {
        verifyPWD.value = true;
        return;
    }

    // const reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6}$/;
    // if (!reg.test(pwd2.value)) {
    //     passwordFlag.value = true;
    //     return;
    // }
    const data = {
        password: pwd2.value,
        userId: userStore.user?.userId ?? ''
    } as IChangePWDComponent;
    userStore.showSpinner();
    userService.value.changePassword(userStore.targetStore!, data)
        .then(data => {
            data as any;
            toast.add(ToastControl.SuccessMessageWithUpdateSuccessful());
            displayFlag.value = false;
            // authService.value.logout();
            // router.push('/login');
        })
        .catch(response => {
            if (response!.data!.return_code!.substring(0, 3) === 'HOS') {
                toast.add(ToastControl.ErrorMessage(response!.data!.message));
            } else {
                toast.add(ToastControl.ErrorMessageWithSystemError());
            }
        })
        .finally(() => {
            // Hide spinner
            userStore.hideSpinner();
        });
}

const dialogHide = () => {
    pwd1.value = '';
    pwd2.value = '';
    verifyPWD.value = false;
    inputCheck.value = false;
}

const passwordFocusRef = ref();

const pwdDialogShow = () => {
    passwordFocusRef.value.$el.children[0].focus();
}

const laravelEcho = ref();

const focusNextByClass = (event: KeyboardEvent, targetClass: string) => {
    FocusControl.setNextFocusByClass(event, targetClass);
    if (targetClass === '.btn-save') {
        const el = document.getElementById('btnSave');
        el?.click();
    }
}

const registerWSListener = () => {
    //Only user logged in the ws channel could be created
    if (userStore.user) {
        if (laravelEcho.value) {
            laravelEcho.value.leaveAllChannels();
        }
        const pusher = require('pusher-js');
        laravelEcho.value = new Echo({
            broadcaster: process.env.VUE_APP_LARAVAL_ECHO_BROADCASTER,
            key: process.env.VUE_APP_LARAVAL_ECHO_KEY,
            cluster: process.env.VUE_APP_LARAVAL_ECHO_CLUSTER,
            wsHost: process.env.VUE_APP_LARAVAL_ECHO_WS_HOST,
            wsPort: Number(process.env.VUE_APP_LARAVAL_ECHO_WS_PORT),
            forceTLS: Boolean(process.env.VUE_APP_LARAVAL_ECHO_FORCE_TLS == 'true'),
            disableStats: Boolean(process.env.VUE_APP_LARAVAL_ECHO_DISABLE_STATS == 'true'),
            authEndpoint: process.env.VUE_APP_LARAVAL_ECHO_AUTH_END_POINT,
            auth: {
                headers: {
                    Authorization: 'Bearer ' + userStore.user.tokenVal, //Bearer is the prefix
                },
            },
        });
        const channelName = `${process.env.VUE_APP_LARAVAL_ECHO_EVENT_PREFIX}.${userStore.user.groupId}.${userStore.user.companyId}.${userStore.user.storeId}`;

        //listen the business date updated event.
        laravelEcho.value!.private(channelName).listen('BusinessDateUpdated', (d: any) => {
            console.log('BUSINESSDATEUPDATED:', d.businessDate);
            userStore.bussinessDate = d.businessDate;
        });
    }
}

const unregisterAllWSChannel = () => {
    if (laravelEcho.value) {
        laravelEcho.value.leaveAllChannels();
    }
}

const autoSearchRejiDataRequestValue = ref('');
const autoSearchRejiDataStart = ref(false);

const registrationListService = ref(new RegistrationListService());

const searchDataItems = ref<any[]>([]);
const customerItems = ref<any[]>([]);
const bookItems = ref<any[]>([]);

const rdStoreList = useRegistrationListStore();
const rdStore = useRegistrationStore();

const autoSearchRejiDataPanelDisplay = ref('none');
const autoSearchRejiDataPanelDisplayFlag = ref(false);
const autoSearchRejiDataPanelMouseFlag = ref(false);

const toRegistration = (event: any) => {
    let data = event;
    if (rejiDataButtonType.value == 'book') {
        rdStoreList.detailBookingBasicInformationId = data.bBasicInformationId;
        rdStoreList.roomUnitId = data.bRoomUnitId;
        rdStore.bBasicInformation.bookingNo = data.bookingNo;
        rdStoreList.editRegulations = true;
        autoSearchRejiDataPanelDisplay.value = 'none';
        autoSearchRejiDataRequestValue.value = '';
        router.push({ path: "/registration/detail", query: { q: Math.random() } });
    } else {
        autoSearchRejiDataPanelDisplay.value = 'none';
        autoSearchRejiDataRequestValue.value = '';
        router.push({ path: "/registration/guest/detail", query: { id: data.customerId } });
        // } else {
        //     router.push({ path: "/registration/guest/detail", query: { p: data.guestPhoneNumber?data.guestPhoneNumber.split(',')[0]:'', n: data.guestNameSingleByte?data.guestNameSingleByte.split('\n')[0]:'' }  });
        // }
    }
}

const toRegistrationCreate = () => {
    router.push({ path: "/registration/detail"});
}

const searchRejiData = (event: any) => {
    if (event) {
        autoSearchRejiDataStart.value = true;
        autoSearchRejiDataRequestValue.value = event;
        registrationListService.value.getRegistrationListToTopBar(autoSearchRejiDataRequestValue.value)
            .then(data => {
                customerItems.value = data.dataGuest as any[];
                bookItems.value = data.dataBook as any[];

                if (autoSearchRejiDataPanelDisplay.value == 'none') {
                    selectedButton.value = 'REJI_BUTTON_TEXT';
                }

                if (selectedButton.value == 'REJI_BUTTON_TEXT') {
                    searchDataItems.value = bookItems.value;
                } else {
                    searchDataItems.value = customerItems.value;
                }
                autoSearchRejiDataPanelDisplay.value = 'block';
            }).finally(() => {
                autoSearchRejiDataStart.value = false;
            });
    }
}

const searchRejiDataBlur = () => {
    autoSearchRejiDataPanelDisplayFlag.value = false;
}

const searchRejiDataClick = () => {
    autoSearchRejiDataPanelDisplayFlag.value = true;
}

const searchRejiDataFocus = () => {
    autoSearchRejiDataPanelDisplayFlag.value = true;
}

const rejiDataButtonType = ref('book');

const regiDataButtonClick = () => {
    rejiDataButtonType.value = 'book';
    searchDataItems.value = bookItems.value;
}

const guestDataButtonClick = () => {
    rejiDataButtonType.value = 'guest';
    searchDataItems.value = customerItems.value;
}

const searchPanelDivGetMouse = () => {
    autoSearchRejiDataPanelMouseFlag.value = true;
}

const searchPanelDivMouseLeave = () => {
    autoSearchRejiDataPanelMouseFlag.value = false;
}

const selectedButton = ref<string>('REJI_BUTTON_TEXT');

const storeOp = ref();

const storeOpClick = (event: any) => {
    storeOp.value.toggle(event);
}

const onStoreSelect = async (data: any) => {
    storeOp.value.hide();
    userStoreId.value = data.id;
    if (userStoreId.value && lastStoreId.value !== userStoreId.value) {
        userStore!.user!.userStores.forEach(store => {
            if (store.storeId === userStoreId.value) {
                userStore!.user!.storeName = store.name;
            }
        })
        userStore!.user!.storeId = userStoreId.value;
        userStore!.targetStore!.storeId = userStoreId.value;


        userStore.showSpinner();

        console.log('change store start')

        await Promise.all([
            requestChangeStore(userStore.loggedUser!.userId, userStoreId.value),
            requestGetStoreInformation(),
            requestGetHolidays()
        ])
            .then((responses) => {
                // getStoreInformation res
                if (responses.length == 3) {

                    // requestChangeStore response
                    const data = responses[0] as IUserInfoComponent;
                    unregisterAllWSChannel();

                    userStore.bussinessDate = data.businessDate;
                    userStore.salesDate = data.salesDate;

                    userStore.targetStore = {
                        groupId: data.groupId,
                        companyId: data.companyId,
                        storeId: data.storeId,
                    };

                    userStore.user!.storeId = data.storeId;

                    const userMenus = data.menus;
                    userStore.menus = userMenus;

                    lastStoreId.value = userStoreId.value;

                    registerWSListener();

                    // requestGetStoreInformation response
                    const storeInfo = responses[1] as IStoreComponent;

                    userStore.currentStoreInformation = storeInfo;

                    // requestGetHolidays response
                    const holidays = responses[2] as IHolidayComponent[];

                    holidayStore.holidays = holidays;
                } else {
                    toast.add(ToastControl.ErrorMessageWithSystemError());
                }
            })
            .catch((response) => {
                if (response!.returnCode!.substring(0, 3) === 'HOS') {
                    toast.add(ToastControl.ErrorMessage(response.message));
                } else {
                    toast.add(ToastControl.ErrorMessageWithSystemError());
                }
            })
            .finally(() => {
                console.log('change store end')
                userStore.hideSpinner();

                countryStore.$reset();
                prefectureStore.$reset();
                rankStore.$reset();

                // freeMemoStore.$reset();
                // salesRouteStore.$reset();
                // purposeStore.$reset();
                // roomTypeStore.$reset();
                // childFeeStore.$reset();

                setTimeout(() => {
                    router.push('/?v=' + Math.random());
                }, 300)
            })
    }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_XTitleLabel = _resolveComponent("XTitleLabel")!
  const _component_Password = _resolveComponent("Password")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_SelectButton = _resolveComponent("SelectButton")!
  const _component_Column = _resolveComponent("Column")!
  const _component_XPageDataTable = _resolveComponent("XPageDataTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "layout-topbar-logo button-clear"
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                style: {"width":"100%","height":"100%"},
                alt: "Logo",
                src: topbarImage(),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (toDashboard()))
              }, null, 8, _hoisted_5)
            ]),
            _: 1
          })
        ]),
        _hoisted_6,
        _createVNode(X1Button, {
          onClick: storeOpClick,
          style: {"margin-left":"35px","background":"transparent","font-size":"20px","border":"0","padding-left":"0"},
          labelProp: _unref(userStore)!.user!.storeName
        }, {
          buttonIconRight: _withCtx(() => [
            (_openBlock(), _createElementBlock("svg", _hoisted_7, _hoisted_10))
          ]),
          _: 1
        }, 8, ["labelProp"]),
        _createVNode(_component_OverlayPanel, {
          ref_key: "storeOp",
          ref: storeOp
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("ul", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(userStore)!.user!.userStores, (store) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: store.id,
                    style: {"cursor":"pointer"},
                    onClick: ($event: any) => (onStoreSelect(store))
                  }, _toDisplayString(store.name), 9, _hoisted_12))
                }), 128))
              ])
            ])
          ]),
          _: 1
        }, 512),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("span", {
            style: {"width":"100%","height":"100%"},
            class: _normalizeClass({ 'p-input-icon-left': true, 'p-input-icon-right': autoSearchRejiDataStart.value })
          }, [
            _hoisted_14,
            _createVNode(_component_InputText, {
              id: "searchRejiDataInput",
              type: "text",
              modelValue: autoSearchRejiDataRequestValue.value,
              "onUpdate:modelValue": [
                _cache[1] || (_cache[1] = ($event: any) => ((autoSearchRejiDataRequestValue).value = $event)),
                searchRejiData
              ],
              placeholder: _unref(t)('TOP_MENU.BOOK_SEARCH'),
              onBlur: searchRejiDataBlur,
              onClick: searchRejiDataClick,
              onFocus: searchRejiDataFocus,
              style: {"width":"100%","height":"100%","padding-left":"69px","font-size":"16px","line-height":"16px","font-family":"Inter"}
            }, null, 8, ["modelValue", "placeholder"]),
            (autoSearchRejiDataStart.value)
              ? (_openBlock(), _createElementBlock("i", _hoisted_15))
              : _createCommentVNode("", true)
          ], 2)
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createVNode(X1Button, {
            labelProp: _unref(t)("TOP_MENU.A_NEW_RESERVATION"),
            style: {"width":"183px","height":"50px","font-size":"16px"},
            onClick: _cache[2] || (_cache[2] = ($event: any) => (toRegistrationCreate()))
          }, {
            buttonIcon: _withCtx(() => [
              _hoisted_18
            ]),
            _: 1
          }, 8, ["labelProp"])
        ]),
        _createElementVNode("div", _hoisted_19, [
          (_openBlock(), _createElementBlock("svg", {
            style: {"outline":"none","cursor":"pointer"},
            onClick: _cache[3] || (_cache[3] = (event) => toggle(event, '2')),
            onBlur: _cache[4] || (_cache[4] = (event) => btnBlur(event, '2')),
            width: "44",
            height: "47",
            viewBox: "0 0 44 47",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, _hoisted_23, 32))
        ]),
        _createVNode(_component_Menu, {
          class: "menu",
          id: "overlay_tmenu2",
          ref_key: "menu2",
          ref: menu2,
          model: menusSection('SECTION03'),
          style: _normalizeStyle([displayMenu2.value, {"z-index":"1001"}])
        }, null, 8, ["model", "style"])
      ])
    ]),
    _createVNode(_component_Dialog, {
      header: _unref(t)('DIALOG.TOP_MENU_PWD_CONFIRM'),
      visible: displayFlag.value,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((displayFlag).value = $event)),
      breakpoints: { '960px': '75vw', '640px': '90vw' },
      style: { width: '400px' },
      class: "p-fluid input-top",
      onShow: pwdDialogShow,
      onHide: dialogHide,
      modal: true
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: _unref(t)('COMMON.BUTTON.SAVE'),
          id: "btnSave",
          class: "btn-save",
          icon: "pi pi-check",
          onClick: onSaveClick
        }, null, 8, ["label"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_24, [
          _createVNode(_component_XTitleLabel, {
            for: "submitPassword1",
            title: _unref(t)('DIALOG.TOP_MENU_PWD')
          }, null, 8, ["title"]),
          _createVNode(_component_Password, {
            ref_key: "passwordFocusRef",
            ref: passwordFocusRef,
            id: "submitPassword1",
            placeholder: _unref(t)("FORGET.PASSWORD_PLACEHOLDER"),
            feedback: false,
            toggleMask: true,
            modelValue: pwd1.value,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((pwd1).value = $event)),
            modelModifiers: { trim: true },
            class: "submit-password1",
            onKeypress: _cache[6] || (_cache[6] = _withKeys(($event: any) => (focusNextByClass($event, '.submit-password2')), ["enter"]))
          }, null, 8, ["placeholder", "modelValue"]),
          (passwordFlag.value)
            ? (_openBlock(), _createElementBlock("small", _hoisted_25, _toDisplayString(passwordValidErrorMesage.value), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createVNode(_component_XTitleLabel, {
            for: "submitPassword2",
            title: _unref(t)('DIALOG.TOP_MENU_PWD_SECOND')
          }, null, 8, ["title"]),
          _createVNode(_component_Password, {
            id: "submitPassword2",
            class: "submit-password2",
            placeholder: _unref(t)("FORGET.PASSWORD_PLACEHOLDER"),
            feedback: false,
            toggleMask: true,
            modelValue: pwd2.value,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((pwd2).value = $event)),
            modelModifiers: { trim: true },
            onKeypress: _cache[8] || (_cache[8] = _withKeys(($event: any) => (focusNextByClass($event, '.btn-save')), ["enter"]))
          }, null, 8, ["placeholder", "modelValue"]),
          (verifyPWD.value)
            ? (_openBlock(), _createElementBlock("small", _hoisted_27, _toDisplayString(_unref(t)("DIALOG.TOP_MENU_PWD_VERIFY")), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["header", "visible"]),
    _createElementVNode("div", {
      onMouseleave: searchPanelDivMouseLeave,
      onMouseenter: searchPanelDivGetMouse,
      class: "shadow-4 border-round fadeinup animation-duration-500",
      style: _normalizeStyle([{"position":"absolute","z-index":"1001","background":"#e7e5e5","top":"5.5rem","height":"800px","overflow-y":"auto"}, 'left: ' + searchRejiDataInputXPosition.value + 'px; display: ' + autoSearchRejiDataPanelDisplay.value])
    }, [
      _createVNode(_component_XPageDataTable, {
        value: searchDataItems.value,
        class: "p-datatable-sm table-custom-right",
        headerShow: true,
        stripedRows: "",
        groupRowsBy: "bookingNo",
        scrollable: "",
        selectionMode: "single",
        ref: "dt",
        id: "registrationListSearchResultTable"
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_28, [
            _createVNode(_component_SelectButton, {
              class: "m-2",
              modelValue: selectedButton.value,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((selectedButton).value = $event)),
              options: buttonConditions.value,
              onChange: _cache[11] || (_cache[11] = ($event: any) => (onSelectedBtnCnd()))
            }, {
              option: _withCtx((slotProps) => [
                _createElementVNode("div", null, _toDisplayString(_unref(t)("REGISTRATION_LIST." + slotProps.option)), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "options"])
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, { style: {"min-width":"4rem","max-width":"4rem"} }, {
            body: _withCtx(({ data }) => [
              _createVNode(_component_Button, {
                onClick: ($event: any) => (toRegistration(data)),
                icon: "pi pi-pencil",
                class: "p-row-editor-init p-link"
              }, null, 8, ["onClick"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "status",
            header: _unref(t)("REGISTRATION_LIST.STATUS"),
            sortable: true,
            style: {"min-width":"8rem"}
          }, {
            body: _withCtx(({ data }) => [
              _createElementVNode("span", {
                class: _normalizeClass('status-badge status-' + data.status.toString().toLowerCase())
              }, _toDisplayString(_unref(t)("REGISTRATION_STATUS." + data.status)), 3)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            field: "bookingNo",
            header: _unref(t)("REGISTRATION_LIST.RESERVATION_NUMBER_BRANCH_NUMBER"),
            sortable: true,
            style: {"min-width":"5rem","max-width":"8rem"}
          }, {
            body: _withCtx(({ data }) => [
              _createElementVNode("span", null, _toDisplayString(data.bookingNo + '-' + data.roomIndex), 1)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            field: "customerGroupsGroupNameSingleByte",
            header: _unref(t)("REGISTRATION_LIST.ORGANIZATION_NAME"),
            sortable: true,
            style: {"min-width":"12rem"}
          }, null, 8, ["header"]),
          _createVNode(_component_Column, {
            field: "guestNameSingleByte",
            header: _unref(t)("REGISTRATION_LIST.GUEST_NAME"),
            style: {"min-width":"12rem"},
            sortable: true
          }, {
            body: _withCtx(({ data }) => [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("p", _hoisted_30, _toDisplayString(data.guestNameSingleByte.split('\n')[0]), 1),
                _createElementVNode("p", _hoisted_31, _toDisplayString(data.guestNameSingleByte.split('\n')[1]), 1)
              ])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            field: "assignedRoomTypeName",
            header: _unref(t)("REGISTRATION_LIST.ROOM_TYPE_NAME"),
            style: {"min-width":"10rem"},
            sortable: true
          }, null, 8, ["header"]),
          _createVNode(_component_Column, {
            field: "assignedRoomNumber",
            header: _unref(t)("REGISTRATION_LIST.BOOKING_NUMBER"),
            sortable: true,
            style: {"min-width":"8rem"}
          }, null, 8, ["header"]),
          _createVNode(_component_Column, {
            field: "checkInDateTime",
            header: _unref(t)("REGISTRATION_LIST.CI_CO"),
            sortable: true,
            style: {"min-width":"10rem"}
          }, {
            body: _withCtx(({ data }) => [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("p", _hoisted_33, _toDisplayString(data.checkInDateTime), 1),
                _createElementVNode("p", _hoisted_34, _toDisplayString(data.checkOutDateTime), 1)
              ])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            field: "guestPhoneNumber",
            header: _unref(t)("REGISTRATION_LIST.PHONE_NUMBER"),
            style: {"min-width":"12rem"},
            sortable: true
          }, {
            body: _withCtx(({ data }) => [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("p", _hoisted_36, _toDisplayString(data.guestPhoneNumber ? data.guestPhoneNumber.split(',')[0] : ''), 1)
              ])
            ]),
            _: 1
          }, 8, ["header"])
        ]),
        _: 1
      }, 8, ["value"])
    ], 36)
  ]))
}
}

})